import { NAME } from './constants';

export const SUBMIT_FORGOT_PASSWORD_FORM = `${NAME}.SUBMIT_FORGOT_PASSWORD_FORM`;
